import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);
export default new Vuetify({
  rtl: true,
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        mainBlue: "#1D398D",
        text: "#0A1A49",
        background: "#F0F0F0",
        midGrey: "#989EAF",
        lightGrey: "#E6E6E6",
        mainRed: "#D9242B",
        error: "#D9242B",
        secondaryYellow: "#FFC436",
        secondaryText: "#454655",
        infoGreen: "#00B38B",
        success: "#00B38B",
        mainTable: "#F5F8FA",
        tableText: "#7E8299",
      },
    },
  },
});
